import React, {Component} from 'react';
import {Transition} from 'react-transition-group';
import Flickity from './Flickity';
import classNames from 'classnames';
import { Link } from 'gatsby';
import createTaxonomyLink from '../utils/createTaxonomyLink';
import {connectToStore} from './Provider';
import ProductCardCarousel from './ProductCardCarousel';
import {opacityFadeDuration} from '../config/animation';

const DESKTOP_SLIDE_OPTIONS = {
	cellAlign: 'left',
	contain: true,
	pageDots: false,
	wrapAround: true,
	prevNextButtons: false,
	freeScroll: true,
	freeScrollFriction: 0.05,
};

const MOBILE_SLIDE_OPTIONS = {
	cellAlign: 'left',
	contain: true,
	pageDots: false,
	wrapAround: true,
	prevNextButtons: false,
	selectedAttraction: 0.1,
	friction: 0.8
};

const COLLECTION_DEFAULT_STYLE = {
	transition: `opacity ${opacityFadeDuration}ms ease-in-out`,
	opacity: 0,
};

const COLLECTION_TRANSITION_STYLES = {
	entering: {opacity: 0},
	entered: {
		opacity: 1,
		transition: `opacity ${opacityFadeDuration}ms ease-in-out ${opacityFadeDuration}ms`,
	},
	exiting: {
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0,
	}
};

class FeaturedCollectionsCarousel extends Component {
	constructor() {
		super();

		this.state = {
			activeCollectionIndex: 0,
		};

		this.sliders = [];
	}

	onSetSliderRef = sliderRef => {
		this.sliders.push(sliderRef);
	}

	setCollectionIndex = activeCollectionIndex => {
		this.setState({activeCollectionIndex});
	}

	onClickPrevious = () => {
		this.sliders.forEach(slider => slider.previous());
	}

	onClickNext = () => {
		this.sliders.forEach(slider => slider.next());
	}

	render() {
		const {
			subtitle,
			title,
			collections,
			shopAllLink,
			openVideoModal,
		} = this.props;

		const {
			activeCollectionIndex
		} = this.state;

		const activeCollection = collections[activeCollectionIndex];

		const desktopCollectionColumns = collections.map((collection, index) => (
			<li
				className="list__item pl2 pr2"
				key={`${index}_${collection._key}`}>
				<button
					title={collection.title}
					className={classNames('media media--horizontal media--forward align--middle gutter--small pb4 link--opacity--invert link--border-after', {
						active: index === activeCollectionIndex
					})}
					onClick={() => this.setCollectionIndex(index)}
					name={collection.title}>
					<span className="media__fixed">
						<img
							alt={collection.title}
							src={collection.icon}
							className="db"
						/>
					</span>
					<span className="media__fluid sans--small uppercase fw--600">
						{collection.title}
					</span>
				</button>
			</li>
		));

		const mobileCollectionColumns = collections.map((collection, index) => (
			<div
				className="col c6 pull-up"
				key={`${index}_${collection._key}`}>
				<div
					className={classNames({
						'pull-left': index % 2 !== 0
					})}>
					<button
						title={collection.title}
						className={classNames('button--collection full-width', {
							active: index === activeCollectionIndex
						})}
						onClick={() => this.setCollectionIndex(index)}
						name={collection.title}>
						<span className="media media--horizontal media--forward align--middle gutter--small pl2 pr2">
							<span className="media__fixed">
								<img
									alt={collection.title}
									src={collection.icon}
									className="db"
								/>
							</span>
							<span className="media__fluid sans--small uppercase fw--600 tl">
								{collection.title}
							</span>
						</span>
					</button>
				</div>
			</div>
		));

		const desktopCollectionList = (
			<div className="show--md">
				<div className="of--hidden">
					<ul className="list list--horizontal gutter--none tc list--forward bb--gray-border">
						{desktopCollectionColumns}
					</ul>
				</div>
			</div>
		);

		const mobileCollectionList = (
			<div className="hide--md">
				<div className="of--hidden">
					<div className="pull-out push-down">
						<div className="row gutter--none">
							{mobileCollectionColumns}
						</div>
					</div>
				</div>
			</div>
		);

		let collectionLink;
		let shopAllLinkButton;

		if (activeCollection.collectionLink._type === 'link') {
			if (activeCollection.collectionLink.url[0] === '/') {
				collectionLink = (
					<Link
						className="full-width button--secondary min-width-lg"
						title={activeCollection.collectionLink.title}
						to={activeCollection.collectionLink.url}>
						{activeCollection.collectionLink.title}
					</Link>
				);
			} else {
				collectionLink = (
					<a
						className="full-width button--secondary min-width-lg"
						title={activeCollection.collectionLink.title}
						href={activeCollection.collectionLink.url}>
						{activeCollection.collectionLink.title}
					</a>
				);
			}
		} else if (activeCollection.collectionLink._type === 'videoModalLink') {
			collectionLink = (
				<button
					title={activeCollection.collectionLink.title}
					className="full-width button--secondary min-width-lg"
					onClick={() => openVideoModal(activeCollection.collectionLink.videoId)}
					name="video">
					{activeCollection.collectionLink.title}
				</button>
			);
		} else if (activeCollection.collectionLink._type === 'taxonomyLink') {
			collectionLink = (
				<Link
					className="full-width button--secondary min-width-lg"
					title={activeCollection.collectionLink.title}
					to={createTaxonomyLink(activeCollection.collectionLink.taxonomies)}>
					{activeCollection.collectionLink.title}
				</Link>
			);
		}

		if (shopAllLink._type === 'link') {
			if (shopAllLink.url[0] === '/') {
				shopAllLinkButton = (
					<Link
						className="full-width button--secondary min-width-lg"
						title={shopAllLink.title}
						to={shopAllLink.url}>
						{shopAllLink.title}
					</Link>
				);
			} else {
				shopAllLinkButton = (
					<a
						className="full-width button--secondary min-width-lg"
						title={shopAllLink.title}
						href={shopAllLink.url}>
						{shopAllLink.title}
					</a>
				);
			}
		} else if (shopAllLink._type === 'videoModalLink') {
			shopAllLinkButton = (
				<button
					title={shopAllLink.title}
					className="full-width button--secondary min-width-lg"
					onClick={() => openVideoModal(shopAllLink.videoId)}
					name="video">
					{shopAllLink.title}
				</button>
			);
		} else if (shopAllLink._type === 'taxonomyLink') {
			shopAllLinkButton = (
				<Link
					className="full-width button--secondary min-width-lg"
					title={shopAllLink.title}
					to={createTaxonomyLink(shopAllLink.taxonomies)}>
					{shopAllLink.title}
				</Link>
			);
		}

		const collectionSlides = collections.map((collection, index) => (
			<Transition
				key={`${index}_${collection._key}`}
				in={index === activeCollectionIndex}
				mountOnEnter
				unmountOnExit
				appear
				timeout={{
					enter: 0,
					exit: opacityFadeDuration,
				}}>{(state) => (
				<div
					style={{
						...COLLECTION_DEFAULT_STYLE,
						...COLLECTION_TRANSITION_STYLES[state]
					}}>
					<div className="show--md">
						<div className="grid-container contained mb5 product-carousel">
							<Flickity
								sliderRef={this.onSetSliderRef}
								options={DESKTOP_SLIDE_OPTIONS}>
								{collection.products.map((product, index) => (
									<div
										className="product-carousel__product-col"
										key={`${index}_${product._key}`}>
										<ProductCardCarousel
											title={product.title}
											slug={product.slug}
											mainImage={product.mainImage}
											cents={product.cents}
											brand={product.brand}
										/>
									</div>
								))}
							</Flickity>
						</div>
					</div>

					<div className="hide--md">
						<div className="grid-container contained product-carousel mb4 pr">
							<Flickity
								sliderRef={this.onSetSliderRef}
								options={MOBILE_SLIDE_OPTIONS}>
								{collection.products.map((product, index) => (
									<div
										className="product-carousel__product-col"
										key={`${index}_${product._key}`}>
										<ProductCardCarousel
											title={product.title}
											slug={product.slug}
											mainImage={product.mainImage}
											cents={product.cents}
											brand={product.brand}
										/>
									</div>
								))}
							</Flickity>
							<button
								title="Previou"
								name="previous"
								onClick={this.onClickPrevious}>
								<img
									className="db flip m--auto"
									alt="next"
									src="/images/icon-carousel-next.svg"
								/>
							</button>
							<button
								title="Next"
								name="next"
								onClick={this.onClickNext}>
								<img
									className="db m--auto"
									alt="next"
									src="/images/icon-carousel-next.svg"
								/>
							</button>
						</div>
					</div>
				</div>
			)}</Transition>
		));

		return (
			<div className="mt8 mb10 of--hidden">
				<div className="pt6--md pb4--md">
					<div className="mb4 mb8--md">
						<div className="grid-container contained">
							<div className="tc">
								<h3 className="uppercase fw--600 mb1 mb2--md">{subtitle}</h3>
								<h2 className="domaine--large mb4 mb5--md">{title}</h2>
							</div>
							{desktopCollectionList}
						</div>
						{mobileCollectionList}
					</div>

					<div className="pr">
						{collectionSlides}
					</div>

					<div className="grid-container contained">
						<ul className="list list--vertical list--vertical-gutter list--horizontal--md list--forward tc gutter--mobile">
							<li className="list__item">
								{collectionLink}
							</li>
							<li className="list__item">
								{shopAllLinkButton}
							</li>
						</ul>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = () => ({});

const mapStoreToProps = ({
	openVideoModal,
}) => ({
	openVideoModal,
});

export default connectToStore(mapStateToProps, mapStoreToProps)(FeaturedCollectionsCarousel);